import Swiper from "swiper/js/swiper.min";
import Chocolat from "chocolat";
import LottieHelper from "../util/lottieHelper";
import ScrollMagic from "ScrollMagic";
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import { TimelineMax } from "gsap";

import letterT from '../lottie/trip/t.json';
import letterR from '../lottie/trip/r.json';
import letterI from '../lottie/trip/i.json';
import letterP from '../lottie/trip/p.json';
import TweenMax from "gsap/TweenMax";

export default {
    init: function () {
        let Lottie = new LottieHelper();

        /**
         * Initialise testimonial slider
         */
        (() => {
            let paginationWrapper = document.querySelector(".testimonial-slide__actions");

            new Swiper('.testimonial-slide__wrapper', {
                slidesPerView: 'auto',
                loop: true,
                observer: true,
                observeParents: true,
                pagination: {
                    el: paginationWrapper.querySelector('.testimonial-slide__pagination'),
                },
                navigation: {
                    nextEl: paginationWrapper.querySelector('.testimonial-slide__next'),
                },
            });
        })();

        /**
         * Loops through image marquee and adds click to
         * expand image + gallery functionality
         */
        (() => {
            $(".chocolat-parent").each(function () {
                let images = [];
                let urls = []; // simple check to see if URL has been added to gallery already.

                $(".image-slideshow__image", $(this)).each(function (i) {
                    let imageIdx = urls.indexOf($(this).data('url'));

                    // image not already added
                    if (imageIdx === -1) {
                        images.push({
                            src: $(this).data('url'),
                        });
                        $(this).data('chocolat-image', i);
                    } else {
                        $(this).data('chocolat-image', urls.indexOf($(this).data('url')));
                    }

                    urls.push($(this).data('url'));
                });

                $(".image-slideshow__image", $(this)).click(function () {
                    api.open($(this).data('chocolat-image'));
                })

                let {api} = Chocolat(images);
            });
        })();


        /**
         * Our values feature
         */
        class ourValuesFeature {
            constructor() {
                this.lottieLetters = {};

                this.insertSVGs();
                this.addEventListeners();

                // play first letter animation
                this.playLetterAnimation('t');
            }

            /**
             * Returns gsap timeline basic timeline to animate
             * outline text
             * @param element html element to animate
             * @returns {gsap.TimelineMax}
             */
            getSlideAnimation(element) {
                let tl = new TimelineMax();
                tl.to(
                    element,
                    1,
                    {
                        width: "100%",
                        ease: "power2.out",
                    }
                ).pause();

                return tl;
            }

            /**
             * Loops through each value and populates the SVG
             * content from lottie JSON file
             */
            insertSVGs() {
                let _this = this;

                $(".trip-feature__description").each(function () {
                    const letter = $(this).data('letter');
                    const json = _this.getLottieJson(letter);
                    const $svgContainer = $(".trip-feature__svg-container", $(this));

                    _this.lottieLetters[letter.toLowerCase()] = Lottie.getLottieAnimation($svgContainer.get(0), json);
                });
            }

            /**
             * Apply click events to trigger visibility
             * of value and associated animation
             */
            addEventListeners() {
                let _this = this;

                $(".trip-feature__title").click(function () {
                    const letter = $(this).data('letter');
                    $(".trip-feature__description.active").removeClass('active');
                    $(".trip-feature__description[data-letter=\"" + letter + "\"]").addClass('active');
                    _this.playLetterAnimation(letter);
                });

                $(".trip-feature__title").each(function () {
                    // create timeline for slide animation
                    const animation = _this.getSlideAnimation($('.fill-text__rect', $(this).get(0)));

                    // add hover / leave events
                    $(this).on('mouseenter', () => {animation.play()});
                    $(this).on('mouseleave', () => {animation.reverse()});
                })
            }

            /**
             * Plays animation
             * @param letter lottie letter to animate
             */
            playLetterAnimation(letter = false) {
                if (!letter) {
                    return false;
                }

                this.lottieLetters[letter].goToAndPlay(0);
            }

            /**
             * Returns Lottie JSON object required
             * to populate and animate letter
             * @param letter what letter shall we load?
             * @returns json
             */
            getLottieJson(letter = false) {
                let json = false;

                switch (letter.toLowerCase()) {
                    case 't':
                        json = letterT;
                        break;
                    case 'r':
                        json = letterR;
                        break;
                    case 'i':
                        json = letterI;
                        break;
                    case 'p':
                        json = letterP;
                        break;
                }
                return json;
            }
        }

        new ourValuesFeature();

        /**
         * Cycle through images on page scroll.
         * @todo: reuse this code instead or repeat (careers)
         */
        (() => {
            jQuery.fn.reverse = [].reverse;
            var controller = new ScrollMagic.Controller();
            createTween();


            function createTween()
            {
                var images = $(".fifty-fifty-image-feature__animated-image > .animated-image-container").get().reverse();

                $(images).each(function (index, element) {
                    let tween = TweenMax.to(element, 0.25, {opacity: 1, ease: "Power2.easeInOut"});

                    const offsetValue = -Math.abs(window.innerHeight / $(images).length) * index;

                    new ScrollMagic.Scene({
                        triggerElement: ".why-join-feature .fifty-fifty-image-feature__row",
                        offset: offsetValue,
                        triggerHook: 0.1,
                    })
                        .setTween(tween) // add class toggle
                        // .addIndicators({name: "digit: " + index + ' offset: ' + offsetValue }) // add indicators (requires plugin)
                        .addTo(controller);
                });
            }
        })();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/careers.js